module.exports = __webpack_public_path__ + "img/Rust-1.5999fde8.png";